export const checkIfDatePassed = (date: string) => {
  if (!date) return true;
  const dateNumber = new Date(date).getTime();
  return dateNumber < new Date().getTime();
};
export const hashEmail = async (email) => {
  const encoder = new TextEncoder();
  const data = encoder.encode(email.trim().toLowerCase());
  const hashBuffer = await crypto.subtle.digest('SHA-256', data);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  const hashHex = hashArray
    .map((b) => b.toString(16).padStart(2, '0'))
    .join('');
  return hashHex;
};
export const checkForConfidential = (confidential: string) =>
  ['STRICTLY_CONFIDENTIAL', 'CONFIDENTIAL'].includes(
    confidential ? confidential.toUpperCase() : 'INTERNAL',
  );
